import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Card } from 'react/card/Card';
import CardTitle from 'react/card/CardTitle';
import ResultsModal from '../../generic/ResultsModal';
import RaisedTextBox from "react/views/generic/RaisedTextBox";
import AcceleratedReaderInputs from './AcceleratedReaderInputs';
import CarouselSearchResults from '../CarouselSearchResults';
import TrackedLink from "react/views/generic/TrackedLink";
import AcceleratedReaderEventTypes from "data/types/AcceleratedReaderEventTypes";
import AcceleratedReaderAdditionalInfo from '../AcceleratedReaderAdditionalInfo';
import CardFooter from 'react/card/CardFooter';
import Button from 'react/views/generic/Button';
import { getFullInterestLevel } from 'data/AcceleratedReaderUtility';
import ReadingLevelOverview from '../ReadingLevelOverview';
import ReadingLevelDetails from '../ReadingLevelDetails';

import "./acceleratedReader.less";

class AcceleratedReader extends Component {
	constructor(props) {
		super(props);
		this.state = {
			searchForResults: false,
			isModalOpen: false,
			inputBookLevel: props.bookLevel,
			inputInterestLevel: props.interestLevel
		};
		this.title = "Accelerated Reader";

		this.openModal = this.openModal.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.openChartModal = this.openChartModal.bind(this);
		this.openResultsModal = this.openResultsModal.bind(this);
		this.handleSearch = this.handleSearch.bind(this);
		this.handleBookLevelChange = this.handleBookLevelChange.bind(this);
		this.handleInterestLevelChange = this.handleInterestLevelChange.bind(this);
	}

	openModal() {
		this.setState({
			isModalOpen: true,
		});
	}

	closeModal() {
		this.setState({
			isModalOpen: false,
		});
	}

	openChartModal() {
		this.setState({ searchForResults: false });
		this.openModal();
	}

	openResultsModal() {
		this.setState({ searchForResults: true });
		this.openModal();
	}

	handleSearch() {
		this.openResultsModal();
		this.props.handleSearch(this.state.inputBookLevel, this.state.inputInterestLevel);
	}

	handleBookLevelChange(evt) {
		this.setState({
			inputBookLevel: evt.target.value
		});
	}

	handleInterestLevelChange(evt) {
		this.setState({
			inputInterestLevel: evt.target.value
		});
	}

	renderSearchButton() {
		return (
			<TrackedLink srcId={this.props.loggingId} destId={this.props.loggingId} featureType={AcceleratedReaderEventTypes.ACCELERATEDREADER_SEARCH_CLICKED}>
				<Button onClick={this.handleSearch} small>Search</Button>
			</TrackedLink>
		);
	}

	render() {
		const shouldSearchForResults = this.state.searchForResults;

		let resultsModal;

		if (shouldSearchForResults) {

			let arResultsHeader = `BASED ON A BOOK LEVEL OF ${this.state.inputBookLevel}`;

			resultsModal = (
				<ResultsModal
					modalTitle={this.title}
					isLoading={this.props.isLoading}
					isOpen={this.state.isModalOpen}
					close={this.closeModal}
				>
					{!this.props.isLoading && <CarouselSearchResults {...this.props} {...this.state} resultsHeader = {arResultsHeader} 
						jacketClickEvent={AcceleratedReaderEventTypes.ACCELERATEDREADER_COVER_CLICKED}
						titleClickEvent={AcceleratedReaderEventTypes.ACCELERATEDREADER_TITLE_CLICKED}
						otsFindItEvent={AcceleratedReaderEventTypes.ACCELERATEDREADER_FINDIT_CLICKED}
						otsClickEvent={AcceleratedReaderEventTypes.ACCELERATEDREADER_AVAILABILITY_CLICKED}
						closeModal={this.closeModal}
					/>}
				</ResultsModal>
			);
		} else {
			resultsModal = (
				<ResultsModal
					isOpen={this.state.isModalOpen}
					isScrollable={true}
					close={this.closeModal}
				>
					<AcceleratedReaderAdditionalInfo />
				</ResultsModal>
			);
		}

		let { bookLevel, interestLevel } = this.props;
		let { inputBookLevel, inputInterestLevel } = this.state;

		return (
			<Card>
				<CardTitle title={this.title} />
				<div className="current-title-accelerated-reader">
					<ReadingLevelOverview>
						<div className="accelerated-reader-value-rectangle">{bookLevel}</div>

						<RaisedTextBox>{getFullInterestLevel(interestLevel)}</RaisedTextBox>
					</ReadingLevelOverview>
					<ReadingLevelDetails>
						<TrackedLink
							featureType={AcceleratedReaderEventTypes.ACCELERATEDREADER_VIEWCHART_CLICKED}
							destId={this.props.loggingId}
							srcId={this.props.loggingId}
						>
							<span className="clickable view-accelerated-reader-chart" onClick={this.openChartModal}>
								View AR info
							</span>
						</TrackedLink>

						<div className="accelerated-reader-range">
							<h3 className="accelerated-reader-title">Browse by AR level</h3>
							<p>Choose a book level and interest level to find more books to read</p>
						</div>
					</ReadingLevelDetails>
					<AcceleratedReaderInputs
						bookLevel={inputBookLevel}
						interestLevel={inputInterestLevel}
						loggingId={this.props.loggingId}
						handleBookLevelChange={this.handleBookLevelChange}
						handleInterestLevelChange={this.handleInterestLevelChange}
					/>
					{resultsModal}
				</div>
				<CardFooter rightContent={this.renderSearchButton()} />
			</Card>
		);
	}
}

AcceleratedReader.propTypes = {
	bookLevel: PropTypes.string.isRequired,
	interestLevel: PropTypes.string.isRequired,
	loggingId: PropTypes.string,
	novelistLink: PropTypes.string,
	isLoading: PropTypes.bool,
	handleSearch: PropTypes.func.isRequired
};

export default AcceleratedReader;



// WEBPACK FOOTER //
// ./src/react/views/readingLevel/acceleratedReader/AcceleratedReader.jsx